import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import IconConcierge from '@spothero/icons/concierge';
import IconPublicTransit from '@spothero/icons/public-transit';
import IconCar from '@spothero/icons/car';
import withConfig from 'config/withConfig';
import SpotImages from 'spot-details/details/SpotImages';
import SpotUtils from 'utils/spot';

export const ShuttleInformation = ({
    isMobile,
    shuttle,
    facilityTitle,
    iataCode,
}) => {
    const {
        type,
        duration,
        fast_frequency: fastFrequency,
        slow_frequency: slowFrequency,
        hours: accessHours,
        images,
    } = shuttle;
    const accessHoursFormatted = accessHours
        ? SpotUtils.formatAccessHours(accessHours)
        : null;
    const frequencySpan =
        fastFrequency && slowFrequency
            ? `${fastFrequency} - ${slowFrequency}`
            : fastFrequency || slowFrequency || '';
    const shuttleDetailsClasses = classnames('ShuttleInformation-details', {
        'no-images': !images.length,
    });
    let subtitle = 'Shuttle Information';

    if (type === 'curbside-valet') {
        subtitle = 'Curbside Dropoff';
    } else if (type === 'public-transit') {
        subtitle = 'Accessible via Public Transit';
    }

    return (
        <div className="ShuttleInformation">
            <h4 className="subtitle">{subtitle}</h4>
            {type === 'taxi' && (
                <span className="ShuttleInformation-no-shuttle">
                    <IconCar />
                    No shuttle available.
                </span>
            )}
            {type === 'public-transit' && (
                <span className="ShuttleInformation-no-shuttle">
                    <IconPublicTransit />
                    No shuttle available, public transit on site.
                </span>
            )}
            {type === 'curbside-valet' && (
                <span className="ShuttleInformation-no-shuttle">
                    <IconConcierge />
                    Concierge service curbside dropoff.
                </span>
            )}
            {(type === 'scheduled' || type === 'on-demand') && (
                <div className="ShuttleInformation-container">
                    <dl className={shuttleDetailsClasses}>
                        <div>
                            <dt className="ShuttleInformation-details-key">
                                Frequency
                            </dt>
                            <dd className="ShuttleInformation-details-value">
                                {frequencySpan && `Every ${frequencySpan} mins`}
                            </dd>
                        </div>
                        <div>
                            <dt className="ShuttleInformation-details-key">
                                Duration to {iataCode}
                            </dt>
                            <dd className="ShuttleInformation-details-value">
                                {duration} mins
                            </dd>
                        </div>
                        <div>
                            <dt className="ShuttleInformation-details-key">
                                Shuttle Hours
                            </dt>
                            <dd className="ShuttleInformation-details-value">
                                {accessHours.text &&
                                    accessHours.text.length === 1 &&
                                    'Operates 24/7'}
                                {accessHoursFormatted &&
                                    accessHoursFormatted.map((period, i) => {
                                        return (
                                            <p
                                                className="hours-of-operation-period"
                                                key={i}
                                            >
                                                <span className="day">
                                                    {period.days}
                                                </span>
                                                , <span>{period.value}</span>
                                                <br />
                                            </p>
                                        );
                                    })}
                            </dd>
                        </div>
                    </dl>
                    {Boolean(images.length) && (
                        <div className="ShuttleInformation-carousel-container">
                            <SpotImages
                                className="ShuttleInformation-carousel"
                                images={images}
                                width={277}
                                height={180}
                                alt={`${facilityTitle} shuttle images`}
                                showArrows={!isMobile}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

ShuttleInformation.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    shuttle: PropTypes.object.isRequired,
    facilityTitle: PropTypes.string.isRequired,
    iataCode: PropTypes.string.isRequired,
};

export default withConfig(['isMobile'])(ShuttleInformation);
